import { prompt } from '../bootbox'

export async function promptNotEmpty(title: string, defaultTitle = ''): Promise<string | null> {
  return await prompt({ title, value: defaultTitle })
}
